import React from 'react';
import { useTranslation } from '../i18n';

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();

  // The translation for policy content returns an array of structured objects.
  // We cast it to the correct type to map over it and render HTML elements.
  const content = t('privacyContent') as unknown as Array<{type: string; text?: string; items?: string[]}>;

  return (
    <div className="bg-slate-800/50 rounded-2xl shadow-xl p-6 sm:p-8 border border-slate-700 animate-fade-in">
      <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-200 mb-4">{t('privacyTitle')}</h1>
      <p className="text-sm text-slate-500 mb-8">{t('privacyLastUpdated')}</p>

      <div className="space-y-6 text-slate-300 leading-relaxed">
        {content.map((item, index) => {
          switch (item.type) {
            case 'h2':
              return <h2 key={index} className="text-2xl font-bold text-slate-200 pt-4 border-t border-slate-700">{item.text}</h2>;
            case 'p':
              return <p key={index}>{item.text}</p>;
            case 'ul':
              return (
                <ul key={index} className="list-disc pl-6 space-y-2">
                  {item.items?.map((li, i) => (
                    // Using dangerouslySetInnerHTML is safe here as the content comes from our own static JSON files.
                    <li key={i} dangerouslySetInnerHTML={{ __html: li }} />
                  ))}
                </ul>
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
